/* Informational estimates only. No cart, checkout or policy mutations. */
(function () {
  'use strict';

  function localNoon(value) {
    if (!(value instanceof Date) || Number.isNaN(value.getTime())) throw new TypeError('A valid local date is required.');
    return new Date(value.getFullYear(), value.getMonth(), value.getDate(), 12);
  }

  function dateKey(value) {
    return [value.getFullYear(), String(value.getMonth() + 1).padStart(2, '0'), String(value.getDate()).padStart(2, '0')].join('-');
  }

  function addDays(value, count, mode) {
    if (!Number.isInteger(count) || count < 0 || count > 365) throw new RangeError('Invalid estimate duration.');
    if (mode !== 'business' && mode !== 'calendar') throw new TypeError('Invalid estimate day mode.');
    var result = localNoon(value);
    for (var added = 0; added < count;) {
      result.setDate(result.getDate() + 1);
      if (mode === 'calendar' || (result.getDay() !== 0 && result.getDay() !== 6)) added++;
    }
    return result;
  }

  function displayRange(start, end, today) {
    var withYear = start.getFullYear() !== today.getFullYear() || end.getFullYear() !== today.getFullYear();
    var formatter = new Intl.DateTimeFormat('en-US', Object.assign({month: 'short', day: 'numeric'}, withYear ? {year: 'numeric'} : {}));
    if (dateKey(start) === dateKey(end)) return formatter.format(start);
    if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
      return new Intl.DateTimeFormat('en-US', {month: 'short'}).format(start) + ' ' + start.getDate() + '–' + end.getDate() + (withYear ? ', ' + end.getFullYear() : '');
    }
    return formatter.format(start) + ' – ' + formatter.format(end);
  }

  function spokenRange(start, end) {
    var format = new Intl.DateTimeFormat('en-US', {month: 'long', day: 'numeric', year: 'numeric'});
    return format.format(start) + ' to ' + format.format(end);
  }

  function timelineFor(value, options) {
    var settings = Object.assign({mode: 'business', processingMin: 1, processingMax: 4, shippingMin: 5, shippingMax: 12}, options || {});
    if (settings.processingMin > settings.processingMax || settings.shippingMin > settings.shippingMax) throw new RangeError('Estimate bounds are reversed.');
    var today = localNoon(value);
    var shipStart = addDays(today, settings.processingMin, settings.mode);
    var shipEnd = addDays(today, settings.processingMax, settings.mode);
    // Transit starts after processing; arrival is never just the transit window from today.
    var arrivalStart = addDays(shipStart, settings.shippingMin, settings.mode);
    var arrivalEnd = addDays(shipEnd, settings.shippingMax, settings.mode);
    return {
      today: dateKey(today), ordered: new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric'}).format(today),
      orderedLabel: new Intl.DateTimeFormat('en-US', {month: 'long', day: 'numeric', year: 'numeric'}).format(today),
      shipped: displayRange(shipStart, shipEnd, today), delivered: displayRange(arrivalStart, arrivalEnd, today),
      shippedLabel: spokenRange(shipStart, shipEnd), deliveredLabel: spokenRange(arrivalStart, arrivalEnd),
      shipStart: dateKey(shipStart), shipEnd: dateKey(shipEnd), arrivalStart: dateKey(arrivalStart), arrivalEnd: dateKey(arrivalEnd),
      mode: settings.mode
    };
  }

  function nextRefreshDelay(now) {
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    return Math.max(100, midnight.getTime() - now.getTime() + 100);
  }

  var calendar = Object.freeze({addDays: addDays, dateKey: dateKey, displayRange: displayRange, timelineFor: timelineFor, nextRefreshDelay: nextRefreshDelay});
  if (typeof module !== 'undefined' && module.exports) module.exports = calendar;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.NovaGlowsShippingTimeline) {
    window.NovaGlowsShippingTimeline.refresh();
    return;
  }

  var refreshTimer;
  function refresh() {
    clearTimeout(refreshTimer);
    var roots = document.querySelectorAll('[data-ng-shipping-timeline]');
    if (!roots.length) return;
    var now = new Date();
    roots.forEach(function (root) {
      var ordered = root.querySelector('[data-ng-shipping-date="ordered"]');
      var shipped = root.querySelector('[data-ng-shipping-date="shipped"]');
      var delivered = root.querySelector('[data-ng-shipping-date="delivered"]');
      if (!ordered || !shipped || !delivered) return;
      try {
        var dates = timelineFor(now, {
          mode: root.dataset.dayMode || 'business',
          processingMin: Number(root.dataset.processingMin || 1), processingMax: Number(root.dataset.processingMax || 4),
          shippingMin: Number(root.dataset.shippingMin || 5), shippingMax: Number(root.dataset.shippingMax || 12)
        });
        ordered.textContent = dates.ordered;
        ordered.dateTime = dates.today;
        ordered.setAttribute('aria-label', dates.orderedLabel);
        shipped.textContent = dates.shipped;
        shipped.setAttribute('aria-label', dates.shippedLabel);
        delivered.textContent = dates.delivered;
        delivered.setAttribute('aria-label', dates.deliveredLabel);
        var note = root.querySelector('[data-ng-shipping-note]');
        if (note) note.textContent = (dates.mode === 'business' ? 'Business day estimates.' : 'Estimated dates.') + ' Delays may occur.';
        root.dataset.estimateDate = dates.today;
        root.setAttribute('aria-label', 'Estimated order and delivery timeline, calculated in ' + dates.mode + ' days' + (dates.mode === 'business' ? ', excluding weekends' : ''));
        root.hidden = false;
      } catch (_) {
        root.hidden = true;
      }
    });
    refreshTimer = setTimeout(refresh, nextRefreshDelay(now));
  }

  window.NovaGlowsShippingTimeline = Object.freeze({refresh: refresh});
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  window.addEventListener('focus', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', function () { setTimeout(refresh, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true});
  refresh();
})();
